export enum LoginIntent {
  OnlineInvoicing = 0,
  Checkout = 1,
  ChangeCartAddress = 2,
}
